import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-salary-forms-8-25-alternate',
    templateUrl: './salary-forms-8-25-alternate.component.html',
    styleUrl: './salary-forms-8-25-alternate.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SalaryForms825AlternateComponent {

}
